import './next-button.scss';
import propTypes from 'prop-types';

export default function NextButton(props) {
  return (
    <button
      {...props}
      className={`next-button ${props.disabled ? 'disabled' : ''}`}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  );
}

NextButton.propTypes = {
  children: propTypes.any,
  disabled: propTypes.bool
};
